import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Svg, Path, Circle } from '@react-pdf/renderer';
const AcuraIncludedIcon = () => (_jsxs(Svg, { style: { width: 16, height: 16 }, viewBox: "0 0 16 16", children: [_jsx(Circle, { cx: "8", cy: "8", r: "8", fill: "#334C96" }), _jsx(Path, { d: "M11.8756 4.97778L6.03498 10.6667L3.91113 8.3394", stroke: "white", strokeWidth: "0.355556", strokeLinecap: "round", strokeLinejoin: "round" })] }));
export default AcuraIncludedIcon;
